import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20an%20epic%20fantasy%20library%20with%20floating%20comic%20pages%20and%20glowing%20books%2C%20warm%20amber%20and%20golden%20light%2C%20magical%20atmosphere%2C%20Korean%20webtoon%20aesthetic%2C%20cinematic%20wide%20composition%2C%20rich%20textures%2C%20dramatic%20lighting%2C%20no%20text&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="韩漫 - 韩国漫画大全背景"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55" />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto text-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            韩漫网站 · 免费阅读韩国漫画
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            精选<strong>好看韩国漫画大全</strong>，支持<strong>下拉式流畅阅读</strong>体验。恋爱、奇幻、动作、悬疑等多元分类，高质量作品持续更新，满足您所有<strong>漫画韩漫</strong>阅读需求。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-primary-500/25"
            >
              立即开始阅读
            </Link>
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg border border-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
            >
              热门恋爱漫画
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">12,000+</div>
              <div className="text-xs text-background-50/60 mt-1">漫画作品</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</div>
              <div className="text-xs text-background-50/60 mt-1">活跃读者</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
              <div className="text-xs text-background-50/60 mt-1">持续连载</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}